import { List } from 'immutable';
import { EventEmitter, OnInit, ElementRef, Component, Output, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { LogService } from '../log/log.service';
import { LookupStore } from '../lookup/lookup.store';

@Component({
  selector: 'pioneer-inline-search-component',
  templateUrl: 'inline-search.component.html'
})
export class InlineSearchComponent implements OnInit {

  @Output('results')
  results: EventEmitter<List<any>> = new EventEmitter<List<any>>();

  @Output('blur')
  blur: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input('placeholderText')
  public placeholderText: string;

  @Input('lookupStore')
  lookupStore: LookupStore<any, any>;

  nameSearch: String;
  hasResults = false;

  constructor(private el: ElementRef,
              private logService: LogService) {
  }

  ngOnInit(): void {

    const eventStream = Observable.fromEvent(this.el.nativeElement, 'keyup')
      .map(() => this.nameSearch)
      .debounceTime(250)
      .share();

    eventStream.filter((text: string) => text && text.length === 0)
      .subscribe(_ => this.setResults(List([])));

    eventStream.filter((text: string) => text && text.length > 1)
      .map((query: string) => this.lookupStore.search(query))
      .switch()
      // act on the return of the search
      .subscribe(
        (results: List<any>) => { // on sucesss
          this.logService.info(`InlineSearchBox: results ${JSON.stringify(results)}`);
          this.setResults(results);
        },
        (error: any) => { // on error
          this.logService.error(`InlineSearchBox: ${error}`);
        }
      );

    this.lookupStore.selected.subscribe(() => {
      // Clear the search field and result dropdown upon selecting a lookup.
      this.resetSearch();
    });

  }

  private setResults(results: any): void {
    if (results instanceof List) {
      this.hasResults = !(results as List<any>).isEmpty();
    }

    if (results instanceof Array) {
      this.hasResults = (results as Array<any>).length > 0;
    }

    this.results.next(results);
  }

  onBlur(): void {
    this.blur.next(true);
    this.resetSearch();
  }

  private resetSearch(): void {
    this.nameSearch = '';
    this.setResults(List([]));
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/inline-search/inline-search.component.ts